export function customConsoleLog(title: string, color: string, fontSize: number, ...data: any) {
  const logTitle = `%c ===> ${title} <===`;
  const logStyle = `color: ${color}; font-size: ${fontSize}px;`;
  console.log('\n');
  console.log(logTitle, logStyle);
  console.log.apply(null, data);
}
